<script lang="ts">
    import {getLocalization} from 'core/svelte-context/context';
    import KpHeading from 'shared/components/kp-heading/KpHeading.svelte';

    const localize = getLocalization();
</script>

<KpHeading type="h1">
    {localize(/* @kp-localization commons.Tezaurus */ 'commons.Tezaurus')}
</KpHeading>